module.exports = __webpack_public_path__ + "img/hr-tank-turret-mask.b7556f1c.png";